import { Checkbox } from 'antd';
import classNames from 'classnames';
import { FC, memo } from 'react';
import './style.scss';
interface IProps {
    children?: React.ReactNode;
    disabled?: boolean;
    autoFocus?: boolean;
    defaultChecked?: boolean;
    indeterminate?: boolean;
    onChange?: () => void;
    field?: any;
    className?: string;
}

const CheckBoxWrap: FC<IProps> = ({
    children,
    className,
    field,
    disabled,
    autoFocus,
    defaultChecked,
    indeterminate,
}) => {
    return (
        <Checkbox
            className={classNames('checkbox__wrap', className)}
            disabled={disabled}
            autoFocus={autoFocus}
            defaultChecked={defaultChecked}
            indeterminate={indeterminate}
            {...field}
            checked={field?.value}
        >
            {children}
        </Checkbox>
    );
};

export default memo(CheckBoxWrap);
